// extracted by mini-css-extract-plugin
export default {"secret__wrapper":"Clients_secret__wrapper__LfAlX","secret__wrapperError":"Clients_secret__wrapperError__snLH1"};